module.exports = __webpack_public_path__ + "img/mongo.06e01b08.svg";